import { Pagination } from 'antd'
import PropTypes from 'prop-types'
import { DEFAULT_PAGE_SIZE } from '../../utils/constant'
import './PaginationCommon.scss'

/**
 * Ant Design 4: page-number changes call `onChange`; page-size changes call
 * `onShowSizeChange` (and sometimes `onChange`). Wire both so size changer works.
 */
export const PaginationCommon = ({
	total,
	align,
	currentPage,
	onChangePage,
	pageSize = DEFAULT_PAGE_SIZE,
	showSizeChanger = true,
	pageSizeOptions = ['10', '20', '50', '100'],
}) => {
	const handleChange = (page, size) => {
		// Size changer is handled by onShowSizeChange — ignore size-only updates here
		// so we don't double-fetch when antd fires both callbacks.
		if (
			size !== undefined &&
			Number(size) !== Number(pageSize) &&
			showSizeChanger
		) {
			return
		}
		onChangePage && onChangePage(page, size)
	}

	const handleShowSizeChange = (_current, size) => {
		// Reset to page 1 when page size changes (standard list UX).
		onChangePage && onChangePage(1, size)
	}

	return (
		<div className={`paginationCommon ${align}`}>
			<Pagination
				total={total}
				current={currentPage}
				pageSize={Number(pageSize)}
				showSizeChanger={showSizeChanger}
				pageSizeOptions={pageSizeOptions}
				onChange={handleChange}
				onShowSizeChange={handleShowSizeChange}
			/>
		</div>
	)
}

PaginationCommon.propTypes = {
	total: PropTypes.number,
	align: PropTypes.string,
	currentPage: PropTypes.number,
	onChangePage: PropTypes.func,
	pageSize: PropTypes.number,
	showSizeChanger: PropTypes.bool,
	pageSizeOptions: PropTypes.arrayOf(PropTypes.string),
}
